import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

type THIS_API = ApiDefinition['/creators/{creatorId}/tasks']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getCreatorTasks = async ({ creatorId, page, perPage, onlyMine, sortByField, sortDirection, teamMembersId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/creators/{creatorId}/tasks', { creatorId });
  const data = await noodleApiClient.get(path, { params: { onlyMine, page, perPage, sortByField, sortDirection, teamMembersId } });
  return data.data;
};

export default getCreatorTasks;
